import { render, staticRenderFns } from "./zhifa.vue?vue&type=template&id=29b6487c&scoped=true&"
import script from "./zhifa.vue?vue&type=script&lang=js&"
export * from "./zhifa.vue?vue&type=script&lang=js&"
import style0 from "./zhifa.vue?vue&type=style&index=0&id=29b6487c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b6487c",
  null
  
)

export default component.exports